import api from './api';

export const getretrieveTransfers = (queryParams) => {
  const {
    filter,
    search,
    page = 1,
    limit = 10,
    sort,
    transfer,
    refund,
    dateLowerRange,
    dateUpperRange,
  } = queryParams;

  const params = new URLSearchParams({
    page,
    limit,
    ...(filter && { filter }),
    ...(sort && { sort }),
    ...(search && { search }),
    ...(transfer && { transfer }),
    ...(refund && { refund }),
    ...(dateLowerRange && { dateLowerRange }),
    ...(dateUpperRange && { dateUpperRange }),
  });

  return api.get(`/api/admin/transfers?${params}`)
    .then(r => r.data)
    .catch(error => {
      console.error('Retrieve transfers error:', error);
      throw error;
    });
};

export const getTransfers = (params) =>
  api.post('/api/admin/gettransfers', params)
    .then(r => r.data)
    .catch(error => {
      console.error('Get transfers error:', error);
      throw error;
    });

export const getTransferById = (transferId) =>
  api.post('/api/admin/gettransfer', { transferId })
    .then(r => r.data)
    .catch(error => {
      console.error('Get transfer error:', error);
      throw error;
    });

export const createTransfer = (transferData) =>
  api.post('/api/admin/createtransfer', transferData)
    .then(r => r.data)
    .catch(error => {
      console.error('Create transfer error:', error);
      throw error;
    });

export const updateTransfer = (transferData) =>
  api.post('/api/admin/updatetransfer', transferData)
    .then(r => r.data)
    .catch(error => {
      console.error('Update transfer error:', error);
      throw error;
    });

export const markTransfer = (payload) =>
  api.post('/api/admin/markTransferCompleted', payload)
    .then(r => r.data)
    .catch(error => {
      console.error('Mark transfer error:', error);
      throw error;
    });

export const processTransfer = (transferId) =>
  api.post('/api/admin/processtransfer', { transferId })
    .then(r => r.data)
    .catch(error => {
      console.error('Process transfer error:', error);
      throw error;
    });

export const deleteTransfer = (transferId) =>
  api.post('/api/admin/deletetransfer', { transferId })
    .then(r => r.data)
    .catch(error => {
      console.error('Delete transfer error:', error);
      throw error;
    });
